import { Controller } from "@hotwired/stimulus";
import { Chart, registerables } from "chart.js";
import ChartJSTrendline from 'chartjs-plugin-trendline';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(...registerables);
Chart.register(ChartJSTrendline);
Chart.register(ChartDataLabels);

export default class extends Controller {
  static targets = ["canvas"];
  static values = {
    chartData: Object,
    url: String,
    type: { type: String, default: "bar" },
    stacked: { type: Boolean, default: false },
    clicked: { type: Boolean, default: false },
    ratio: { type: Boolean, default: true }
  };

  connect() {
    let options = {
      responsive: true,
      maintainAspectRatio: this.ratioValue,
      plugins: {
        datalabels: { display: false }
      }
    };

    if (this.typeValue === "bar" && this.stackedValue) {
      options.scales = {
        x: { stacked: true },
        y: { stacked: true }
      };
      options.plugins.datalabels = {
        display: true,
        font: { size: 10 },
        color: "gray",
        anchor: "end",
        align: "top",
        formatter: (value, ctx) => {
          const datasets = ctx.chart.data.datasets;
          if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
            let sum = 0;
            datasets.forEach(dataset => {
              sum += dataset.data[ctx.dataIndex];
            });
            return sum.toString();
          } else {
            return '';
          }
        }
      };
    }

    if (this.isPieOrDoughnut()) {
      options.plugins.legend = {
        display: false
      };
      options.plugins.datalabels = {
        display: true,
        color: '#fff',
        font: { weight: 'bold', size: 11 },
        formatter: (value, ctx) => {
          const total = ctx.dataset.data.reduce((a, b) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(1);
          return percentage > 3 ? `${percentage}%` : '';
        }
      };

      if (this.typeValue === "doughnut") {
        options.cutout = '65%';
      }
    }

    if (this.clickedValue && this.hasUrlValue) {
      let clickOption = {
        onHover: (event, elements) => {
          event.native.target.style.cursor = elements.length > 0 ? 'pointer' : 'default';
        },
        onClick: (event, elements) => {
          this.handleChartClick(elements);
        }
      };
      options = { ...options, ...clickOption };
    }

    this.chart = new Chart(this.canvasTarget.getContext("2d"), {
      type: this.typeValue,
      data: this.chartDataValue,
      options: options,
    });
  }

  isPieOrDoughnut() {
    return this.typeValue === "pie" || this.typeValue === "doughnut";
  }

  handleChartClick(elements) {
    if (!elements || elements.length === 0) return;

    const index = elements[0].index;
    const label = this.chart.data.labels[index];
    const baseUrl = this.urlValue;

    const params = new URLSearchParams({ date: label });

    const frame = document.getElementById("details_frame");
    if (frame) {
      frame.src = `${baseUrl}?${params.toString()}`;
    }
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
